import { Button, Input, Select, Switch } from "antd";
import { TableProps } from "antd/es/table";
import { useState } from "react";
import AddIcon from "../../../../assets/icons/AddIcon";
import EditIcon from "../../../../assets/icons/EditIcon";
import FilterIcon from "../../../../assets/icons/FilterIcon";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import ViewIcon from "../../../../assets/icons/ViewIcon";
import AddNewRole from "../../../../components/RoleCreate/AddNewRole";
import CustomTable from "../../../../components/ui/CustomTable";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../../utils/number";
import {
  selectSearchOption,
  selectStringOption,
} from "../../../../utils/utils";

export default function RoleCreate() {
  const { page, limit, handlePagination, handleLimit } = useTable();
  const { handleClose, handleOpen, open } = useModal();
  const [switchStatus, setSwitchStatus] = useState(false);

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: "Role Type",
      dataIndex: "roleType",
    },

    {
      title: "Role Name",
      dataIndex: "name",
    },
    {
      title: "Created at",
      dataIndex: "date",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 116,
      render: (value) => (
        <div className="flex gap-x-1">
          <Switch size="small" onChange={(val) => setSwitchStatus(val)} />
          <span className="">{switchStatus ? "Active" : "Inactive"}</span>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val) => (
        <div className="flex justify-center items-center gap-2">
          <Button
            className="action-button"
            size="small"
            icon={<EditIcon />}
            // onClick={() =>
            //   handleOpen({
            //     type: "UPDATE",
            //     data: val,
            //   })
            // }
          />

          <Button className="action-button" size="small" icon={<ViewIcon />} />
        </div>
      ),
    },
  ];

  return (
    <SidebarLayout title="Role List">
      <CustomTable
        loading={false}
        limit={limit}
        page={page}
        columns={columns}
        total={120} // Update total as per the data
        dataSource={data}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search"
              style={{ width: 220 }}
            />

            <Select
              allowClear
              showSearch
              placeholder="Filter"
              filterOption={selectSearchOption}
              // options={selectStringOption([
              //   "IT",
              //   "Design",
              //   "Development",
              //   "Mobile App",
              // ])}
              className="min-w-[130px]"
              suffixIcon={<FilterIcon />}
              rootClassName="icon-gray"
            />

            <Select
              allowClear
              showSearch
              placeholder="Status"
              filterOption={selectSearchOption}
              options={selectStringOption(["Active", "Inactive"])}
              className="min-w-[90px]"
              suffixIcon={<SelectDownIcon />}
              rootClassName="icon-gray"
            />

            <Button
              type="primary"
              className="middle-button"
              icon={<AddIcon />}
              onClick={() =>
                handleOpen({
                  type: "ADD",
                })
              }
            >
              Add New User
            </Button>
          </>
        }
      />
      {/* Modal */}
      {open.type === "ADD" && (
        <AddNewRole
          open={open.open}
          data={open?.data}
          type={open?.type}
          handleClose={handleClose}
        />
      )}
    </SidebarLayout>
  );
}

interface DataType {
  name: string;
  roleType: string;

  date: string;
  status: string;
  id: string;
}

const data: DataType[] = [
  {
    name: "pio jubayer vai",
    roleType: "chairman",
    date: "10 Jan, 2025",
    status: "Active",
    id: "1",
  },
  {
    name: "pio baker vai",
    roleType: "vice chairman",
    date: "10 Jan, 2025",
    status: "Inactive",
    id: "2",
  },
];
